import { Route } from '@angular/router';
import { NotFoundPage } from './not-found-page';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@moofyvip-ui-landing'),
  },
  {
    path: '',
    data: { preload: true, preloadPriority: 1 },
    loadChildren: () => import('@ws-moofyvip/moofyvip-ui-dashboard'),
  },
  {
    path: '**',
    title: 'Página no encontrada',
    component: NotFoundPage,
  },
];
